import Header from "../../components/Header"
import Footer from "../../components/Footer"

import code1 from "../../assets/synthcode1.webp"
import code2 from "../../assets/synthcode2.webp"
import code3 from "../../assets/synthcode3.png"
import ContactButton from "../../components/ContactButton"
import InfoPanelBlue from "../../components/InfoPanelBlue"
import InfoPanelPink from "../../components/InfoPanelPink"
import InfoPanelPurple from "../../components/InfoPanelPurple"
import SubtitleRule from "../../components/SubtitleRule"
import "./page.css"


export default function Home() {
    return (
        <div className="relative w-screen overflow-hidden">
            <Header />
            <div className="w-screen bg-black flex flex-col items-center py-[50px] text-center">
                <SubtitleRule text="About us"/>
                <div className="w-full flex flex-row justify-center flex-wrap pt-[50px]">
                    <InfoPanelBlue title="Who are we?" text="We are CodeWave Solutions, a computer programming company that provides services for businesses and individuals with total confidentiality, anonymity and assured quality." />
                    <InfoPanelPink title="What services do we provide?" text="CodeWave Solutions provide web development services, tools, bots and general purpose software design and development. Check out the services page for more information." />
                    <InfoPanelPurple title="How do I contact you?" text="In the interest of anonymity, privacy and safety, CodeWave Solutions operates mostly through Telegram. The channel link can be found on our Contact Us page. Discord is an option too!" />
                </div>
                <div className="py-[100px]">
                <h3 className="inline-block text-transparent bg-clip-text bg-gradient-to-r from-sky-400 to-fuchsia-600 pt-[50px]">Professional</h3>
                <h3 className="pb-[100px]">Service</h3>
                <div className="w-full pt-0 p-[50px] flex flex-col md:flex-row items-center">
                    <img src={code1} className="md:w-1/2 rounded-3xl my-8"/>
                    <div className="px-8 md:text-left flex flex-col items-center text-center md:w-1/2">
                        <h4 className="inline-block text-transparent bg-clip-text bg-gradient-to-r from-sky-400 to-fuchsia-600 pt-[50px]">Web Development</h4>
                        <p className="py-4 text-left">
                            • Website theme and palette design <br/>
                            • Full-stack development using modern and up-to-date technologies <br/>
                            • Enhanced website and server security with expert knowledge <br/>
                            • Consistent workflow suitable for returning customers and ongoing projects <br/>
                            • Timely updates and project completion to suit your needs
                        </p>
                        <ContactButton text="Comission a site"/>
                    </div>
                </div>
                <div className="md:hidden w-full p-[50px] flex flex-col md:flex-row items-center">
                    <img src={code2} className="md:w-1/2 rounded-3xl my-8"/>
                    <div className="px-8 md:text-left flex flex-col items-center text-center md:w-1/2">
                        <h4 className="inline-block text-transparent bg-clip-text bg-gradient-to-r from-sky-400 to-fuchsia-600 pt-[50px]">Specialised Tools</h4>
                        <p className="py-4 text-left">
                            • Tools designed for all your needs <br/>
                            • Cyber security technology for testing website defence mecahnisms <br/>
                            • Advanced data retrieval tools <br/>
                            • Software designed to work with any website of your choosing <br/>
                            • Future support available should any tools become defunct
                        </p>
                        <ContactButton text="Request a tool"/>
                    </div>
                </div>
                <div className="hidden w-full p-[50px] md:flex flex-col md:flex-row items-center">
                    <div className="px-8 md:text-left flex flex-col items-center text-center md:w-1/2">
                        <h4 className="inline-block text-transparent bg-clip-text bg-gradient-to-r from-sky-400 to-fuchsia-600 pt-[50px]">Specialised Tools</h4>
                        <p className="py-4 text-left">
                            • Tools designed for all your needs <br/>
                            • Cyber security technology for testing website defence mecahnisms <br/>
                            • Advanced data retrieval tools <br/>
                            • Software designed to work with any website of your choosing <br/>
                            • Future support available should any tools become defunct
                        </p>
                        <ContactButton text="Request a tool"/>
                    </div>
                    <img src={code2} className="md:w-1/2 rounded-3xl my-8"/>
                </div>
                <div className="w-full p-[50px] flex flex-col md:flex-row items-center">
                    <img src={code3} className="md:w-1/2 rounded-3xl my-8"/>
                    <div className="px-8 md:text-left flex flex-col items-center text-center md:w-1/2">
                        <h4 className="inline-block text-transparent bg-clip-text bg-gradient-to-r from-sky-400 to-fuchsia-600 pt-[50px]">Personalised Bots</h4>
                        <p className="py-4 text-left">
                            • Bots designed for communication apps, social media sites, etc. <br/>
                            • Almost anything can be automataed, ask our team about your needs! <br/>
                            • Hands-free task automation designed to stop you wasting your time <br/>
                            • Work with any API which you require access to <br/>
                            • Future support available should any bots become defunct
                        </p>
                        <ContactButton text="Ask about bots" />
                    </div>
                </div>
                </div>
                <SubtitleRule text="Contact us"/>
                <h3 className="inline-block text-transparent bg-clip-text bg-gradient-to-r from-sky-400 to-fuchsia-600 p-[50px]">Like what you see?</h3>
                <ContactButton text="Contact Us"/>
            </div>
            <Footer />
        </div>
    );
}